// src/utils/navTracker.js

/**
 * @module navTracker
 * @description 导航方向追踪器（router.beforeEach 注入版）
 * * 【为什么要升级】
 * v1 版采用"谁调用谁消费"模式，存在严重漏洞：popstate 触发后，如果中间途经的页面
 * 没有调用 consumeIsBack（比如 /index 大看板没用 listMixin），标记位会一直残留，
 * 被下一次进入列表页时错误消费，导致从大看板再次跳转时被误判为"返回动作"而熔断不刷新。
 * * 【v2 修复思路】
 * 把"消费时机"统一收口到 router.beforeEach，每次路由切换都把当前的 popstate 状态
 * 同步到 currentIsBack，并立即清空原始标记。这样无论中间经过哪些页面，每次进入新页面
 * 时 navTracker.isBack() 都准确反映"本次路由切换是不是返回动作"。
 */

let isPopNavigation = false;  // popstate 原始标记
let currentIsBack = false;    // 当前路由切换的方向（由 beforeEach 同步）

window.addEventListener('popstate', () => {
    isPopNavigation = true;
});

/**
 * @description 把方向追踪器注入到 router，必须在 main.js 中调用一次
 * @param {Object} router
 */
export function installNavTracker(router) {
    router.beforeEach((to, from, next) => {
        // ⚡ 直接给 meta 添加属性，不整体赋值
        // to.meta 在 vue-router 里始终存在（即使路由没声明 meta，也会是 {}）
        to.meta._isBack = isPopNavigation;
        isPopNavigation = false;
        next();
    });
}

export const navTracker = {
    isBack(to) {
        return !!(to && to.meta && to.meta._isBack);
    }
};
